import React, { useState, useRef, useEffect } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

interface LoadingButtonProps {
    label: React.ReactNode; // label prop'u hem metin hem de React bileşeni olabilir
    onClick: (event: React.FormEvent) => void; // Adjusted to accept FormEvent
    style?: React.CSSProperties; // style prop'u opsiyonel ve CSSProperties türünde
    className?: string;
    tooltipText?: string; // Tooltip text'i prop olarak ekleyelim
}

const LoadingButton: React.FC<LoadingButtonProps> = ({ label, onClick, style, className, tooltipText }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [showTooltip, setShowTooltip] = useState(false);
    const targetRef = useRef(null);
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);

    const handleClick = async (event: React.FormEvent) => {
        setIsLoading(true);
        setShowTooltip(false); // Tooltip'i kapat
        clearTimeout(timeoutRef.current!); // Açık olan timeout'u temizle
        try {
            await onClick(event);
        } finally {
            setIsLoading(false);
        }
    };

    const handleMouseEnter = () => {
        setShowTooltip(true);
        timeoutRef.current = setTimeout(() => {
            setShowTooltip(false);
        }, 3000); // 3 saniye sonra Tooltip'i gizle
    };

    const handleMouseLeave = () => {
        setShowTooltip(false);
        clearTimeout(timeoutRef.current!); // Açık olan timeout'u temizle
    };

    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current); // Bileşen unmount olduğunda timeout'u temizle
            }
        };
    }, []);

    const buttonClassName = className || 'btn btn-primary';

    const buttonElement = (
        <button
            className={buttonClassName}
            onClick={handleClick}
            disabled={isLoading}
            style={style}
            ref={targetRef}
            onMouseEnter={handleMouseEnter} // Mouse üzerine geldiğinde Tooltip'i göster
            onMouseLeave={handleMouseLeave} // Mouse dışarı çıktığında Tooltip'i gizle
        >
            {isLoading ? (
                <span className="spinner spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            ) : (
                label
            )}
        </button>
    );

    return tooltipText ? (
        <OverlayTrigger
            placement="top"
            overlay={<Tooltip>{tooltipText}</Tooltip>}
            show={showTooltip} // Tooltip'in gösterilip gösterilmeyeceğini kontrol et
        >
            {buttonElement}
        </OverlayTrigger>
    ) : (
        buttonElement
    );
};

export default LoadingButton;
